import * as React from 'react';
import clsx from 'clsx';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

import styles from './styles.module.scss';

export const StatusTooltip = ({
  className,
  children,
  ...props
}: TooltipProps) => {
  return (
    <Tooltip
      {...props}
      classes={{
        tooltip: clsx(styles.root, className),
      }}
    >
      {children}
    </Tooltip>
  );
};
